import { useState } from 'react';
import BannerToggle from '@/common/FeatureBranch/BannerToggle';
import BranchInfo from '@/common/FeatureBranch/BranchInfo';
import ClearButton from '@/common/FeatureBranch/ClearButton';

type OwnProps = {
  currentNativeAppCapabilities?: string;
  onOpenPassengerTools: () => void;
};

export default function FeatureBranchBanner({
  currentNativeAppCapabilities,
  onOpenPassengerTools
}: OwnProps) {
  const [showBanner, setShowBanner] = useState(true);

  return (
    <div className="m-4 flex w-fit max-w-full items-center bg-yellow-2 p-4 opacity-90">
      <BannerToggle
        showBanner={showBanner}
        onToggle={() => setShowBanner(v => !v)}
      />

      {showBanner ? (
        <>
          <BranchInfo
            currentNativeAppCapabilities={currentNativeAppCapabilities}
            onOpenPassengerTools={onOpenPassengerTools}
          />
          <ClearButton />
        </>
      ) : null}
    </div>
  );
}
